import { render, staticRenderFns } from "./TransactionProfile.vue?vue&type=template&id=ab0dc314&scoped=true"
import script from "./TransactionProfile.vue?vue&type=script&lang=js"
export * from "./TransactionProfile.vue?vue&type=script&lang=js"
import style0 from "./TransactionProfile.vue?vue&type=style&index=0&id=ab0dc314&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab0dc314",
  null
  
)

export default component.exports